import { render } from "./TableQualifiedRegistered.vue?vue&type=template&id=dcf1201c&scoped=true"
import script from "./TableQualifiedRegistered.vue?vue&type=script&lang=js"
export * from "./TableQualifiedRegistered.vue?vue&type=script&lang=js"

import "./TableQualifiedRegistered.vue?vue&type=style&index=0&id=dcf1201c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-dcf1201c"

export default script